import { render, staticRenderFns } from "./editSku.vue?vue&type=template&id=b0705cc8&scoped=true"
import script from "./editSku.vue?vue&type=script&lang=js"
export * from "./editSku.vue?vue&type=script&lang=js"
import style0 from "./editSku.vue?vue&type=style&index=0&id=b0705cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0705cc8",
  null
  
)

export default component.exports